import { useState, useEffect } from 'react';
import { getScrollbarWidth } from '../scrollbarWidth/index.js';

const useScrollbarWidth = () => {
  const [scrollbarWidth, setScrollbarWidth] = useState(0);

  const updateScrollbarWidth = () => {
    const width = getScrollbarWidth();
    setScrollbarWidth(width);
  };

  useEffect(() => {
    window.addEventListener('resize', updateScrollbarWidth);
    updateScrollbarWidth();
    return () => window.removeEventListener('resize', updateScrollbarWidth);
  }, []);
  return {
    scrollbarWidth
  };
};

export { useScrollbarWidth };
